var i = [
  /dynamically imported module/i,
  /importing a module script failed/i,
  /failed to load module script/i,
  /unable to preload css/i,
  /loading chunk \S+ failed/i,
  /chunkloaderror/i
], a = "dev-build", d = "${";
export {
  d as BUILD_VERSION_PLACEHOLDER_PREFIX,
  i as CHUNK_IMPORT_FAILURE_PATTERNS,
  a as DEV_BUILD_VERSION
};

//# sourceMappingURL=chunkError.constants.js.map